import React from 'react';
import { EditorStringModel } from '../../Types/EditorString';
import EditorString from '../EditorString/EditorString';

const ProductPageTrustabilityTab = ({
  shippingInfo,
  returnInfo,
}: {
  shippingInfo: EditorStringModel;
  returnInfo: EditorStringModel;
}) => {
  return shippingInfo || returnInfo ? (
    <div className="grid lg:grid-cols-2">
      <div className="flex flex-col gap-y-6">
        {shippingInfo?.value && (
          <div>
            <EditorString {...shippingInfo} />
          </div>
        )}
        {returnInfo && (
          <div>
            <EditorString {...returnInfo} />
          </div>
        )}
      </div>
    </div>
  ) : null;
};

export default ProductPageTrustabilityTab;
